import React, {useContext, useState, useEffect} from "react";
import TranslationContext from "../../../context/TranslationContext"


const m = {
    ru: "Русский",
    en: "English",
    fr: "Français",
    ar: "عربي",
    zh: "中文",
    de: "Deutsch",
    es: "Español",
}

// use in Skin
export const LangSelector = ({langs}) => {
    const {setLanguage} = useContext(TranslationContext)

    
    const setLang = (lng) => {
        document.documentElement.lang = lng
        setLanguage(lng)
    }

    return <>
        {
            langs.map((lang, index) => <a
                id="head_lang_link"
                onClick={() => setLang(lang)}
                key={`${lang}-${index}`}
                className = "lang-inline ml-1"
            >{m[lang]}</a>)
        }
    </>
}


const LangChanger = ({setLangKey, handlerFunc = undefined }) => {
    // debugger
    const { getTranslation, setLanguage } = useContext(TranslationContext)

    // key = "ru" // "en" // "es" ....
    const handlerClick = () => {
        if (handlerFunc !== undefined) {
            handlerFunc(setLangKey)
            return
        }
        // document.documentElement.lang = setLangKey
        setLanguage(setLangKey)
        let allElements = document.querySelectorAll('[data-id_phrase]')
        let counter = allElements.length
        // debugger
        const phr = JSON.parse(localStorage.getItem("lng_json"))

        for (let i = 0; i < counter; i++) {
            let el = allElements[i]
            // debugger
            if (getTranslation(el.dataset.id_phrase) !== "") {
                // console.log(getTranslation(el.dataset.id_phrase))
                el.innerHTML = `<span>${getTranslation(el.dataset.id_phrase)}</span>`
            }
        }
    }

    return <span onClick={handlerClick}>{m[setLangKey]}</span>
}



export const LangChangerCopy = ({setLangKey, textFormat = false }) => {
    const { getTranslation, setLanguage } = useContext(TranslationContext)
    // key = "ru" // "en" // "es" ....
    const handlerClick = () => {
        let allElements = document.querySelectorAll('[data-id_phrase]')
        let counter = allElements.length
        const phr = JSON.parse(sessionStorage.getItem("lng_json"))
        setLanguage(setLangKey)
        for (let i = 0; i < counter; i++) {
            let el = allElements[i]
            if (phr[el.dataset.id_phrase]) {
                el.innerHTML = phr[el.dataset.id_phrase][setLangKey]
            }
        }
    }

    return <span onClick={handlerClick}>{(textFormat) ? textFormat : m[setLangKey]}</span>
}

export default LangChanger